import { render, staticRenderFns } from "./MessageAdvancedSearchSelect.vue?vue&type=template&id=56c2330a&scoped=true&"
import script from "./MessageAdvancedSearchSelect.vue?vue&type=script&lang=js&"
export * from "./MessageAdvancedSearchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c2330a",
  null
  
)

export default component.exports